import React from 'react';
import { compose } from 'redux';
import { withTranslation, WithTranslation } from 'react-i18next';
import { Stats, Props as WidgetProps } from './Stats';
import reduxConnectContainer from './Stats.container';
import WidgetBoxWide, {
  Props as WidgetBoxWideProps,
} from '../_partials/WidgetBoxWide';

const enhance = compose(
  reduxConnectContainer,
  withTranslation()
);
class StatsInExpandedWidgetContainer extends React.Component<
  WidgetProps & WidgetBoxWideProps & WithTranslation
> {
  render() {
    const {
      id,
      subHeader,
      headerExtraElementsOnMobile,
      isHeaderStickyOnMobile,
      widgetMoveUp,
      widgetMoveDown,
      widgetRemove,
      parentRef,
      widgetBoxClassName,
      ...props
    } = this.props;

    return (
      <WidgetBoxWide
        id={id}
        header={props.t!('widgets.statistics.header')}
        headerExtraElementsOnMobile={headerExtraElementsOnMobile}
        isHeaderStickyOnMobile={isHeaderStickyOnMobile}
        moduleId={props.moduleId}
        parentRef={parentRef}
        widgetMoveUp={widgetMoveUp}
        widgetMoveDown={widgetMoveDown}
        widgetRemove={widgetRemove}
        className={widgetBoxClassName}
      >
        <Stats {...props} />
      </WidgetBoxWide>
    );
  }
}

export default enhance(StatsInExpandedWidgetContainer) as React.ComponentType<
  Pick<
    WidgetBoxWideProps,
    | 'moduleId'
    | 'id'
    | 'isHeaderStickyOnMobile'
    | 'subHeader'
    | 'headerExtraElementsOnMobile'
  >
>;
